"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.walletSwapperSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const WalletSwapInterface_1 = require("../WalletSwapInterface");
const initialSwapState = Object.assign({}, WalletSwapInterface_1.defaultSwapState);
exports.walletSwapperSlice = (0, toolkit_1.createSlice)({
    name: "walletSwapperWrapper",
    initialState: initialSwapState,
    reducers: {
        startSwap: (state) => {
            state.swapModalShow = true;
            state.isSwapping = true;
        },
        initiateSwap: (state, action) => {
            state.sourceNetwork = action.payload.sourceNetwork;
            state.targetNetwork = action.payload.targetNetwork;
            state.isSwapped = false;
            state.transactionId = "";
        },
        transactionIdReceived: (state, action) => {
            state.isSwapped = false;
            state.transactionId = action.payload.transactionId;
        },
        transactionCompleted: (state) => {
            state.isSwapping = false;
            state.isSwapped = true;
        },
        transactionSwapStatus: (state, action) => {
            state.status = action.payload.status;
        },
        transactionFailed: (state) => {
            state.isSwapping = false;
            state.isSwapped = false;
            state.transactionId = "";
            state.swapModalShow = false;
        },
        resetSwapModal: (state) => {
            state.swapModalShow = false;
        },
        swapReset: (state) => {
            state.sourceNetwork = "";
            state.targetNetwork = "";
            state.isSwapped = false;
            state.isSwapping = false;
            state.swapModalShow = false;
            state.transactionId = "";
            state.status = "";
        },
    },
});
//# sourceMappingURL=WalletSwapWrapperSlice.js.map